import { createContext } from 'preact';

export type AccordionItemStylingVariant = 'basic' | 'accordion';


export type AccordionItemStylingContextProps = {
 stylingVariant: AccordionItemStylingVariant
};

export const AccordionItemStylingContext = createContext<AccordionItemStylingContextProps>({stylingVariant: 'basic'});
